// extracted by mini-css-extract-plugin
export default {"tableContainer":"StaffRanking_tableContainer__g3X7R","upDownButton":"StaffRanking_upDownButton__1Of13","iconBox":"StaffRanking_iconBox__pm9q7","icon":"StaffRanking_icon__qMijO"};